export { useProgramTabs } from './useProgramTabs';
export { useProgramConsents } from './useProgramConsents';



// WEBPACK FOOTER //
// ./src/components/Programs/hooks/index.js